function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Decimal from "decimal.js";
import { OrderTypeDesc } from "TradeAPILib";
import NumberUtils from "../../../utils/NumberUtils";
import TradeCreateOrderBaseModel from "../../TradeCreateOrderBaseModel";
import { TradeCreateOrderError } from "../../TradeCreateOrderError";
var GridCreateOrderModel = /*#__PURE__*/function (_TradeCreateOrderBase) {
  _inherits(GridCreateOrderModel, _TradeCreateOrderBase);
  var _super = _createSuper(GridCreateOrderModel);
  function GridCreateOrderModel(n) {
    var _this;
    _classCallCheck(this, GridCreateOrderModel);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "param", void 0);
    _this.param = n;
    return _this;
  }
  _createClass(GridCreateOrderModel, [{
    key: "checkGridPerVolumeRequest",
    value: function checkGridPerVolumeRequest() {
      var _this$param = this.param,
        market = _this$param.market,
        high = _this$param.high,
        low = _this$param.low,
        grid_count = _this$param.grid_count,
        symbol = _this$param.symbol,
        grid_balance_percent = _this$param.grid_balance_percent,
        baseBalance = _this$param.baseBalance,
        quoteBalance = _this$param.quoteBalance;
      var isVaild = this.isNumberStrVaild;
      if (!grid_balance_percent) {
        throw TradeCreateOrderError.Grid_AI_Need_Balance_Percent;
      }
      if (grid_balance_percent > 0.95) {
        throw TradeCreateOrderError.Amount_Rather_Than_95_Percent;
      }
      if (baseBalance === undefined || quoteBalance === undefined) {
        throw TradeCreateOrderError.Balance_Get_Failed;
      }
      if (!isVaild(high) || !isVaild(low) || !high || !low) {
        throw TradeCreateOrderError.Grid_Price_Empty;
      }
      if (low >= high) {
        throw TradeCreateOrderError.Grid_Price_Rance_Error;
      }
      if (!isVaild(grid_count) || !grid_count) {
        throw TradeCreateOrderError.Grid_Params_Error;
      }
      var request = {
        balance_percent: "".concat(grid_balance_percent),
        got_base_amount: "".concat(baseBalance),
        got_quote_amount: "".concat(quoteBalance),
        market: market,
        base: symbol.base,
        quote: symbol.quote,
        top: high,
        bottom: low,
        per_volume: 0,
        row_cnt: grid_count,
        precision: symbol.precision || 4,
        limits: symbol.limit
      };
      return request;
    }
  }, {
    key: "checkGridRequiredBalanceRequest",
    value: function checkGridRequiredBalanceRequest(customPerVolume) {
      var _this$param2 = this.param,
        high = _this$param2.high,
        low = _this$param2.low,
        grid_per_volume = _this$param2.grid_per_volume,
        grid_count = _this$param2.grid_count,
        baseBalance = _this$param2.baseBalance,
        quoteBalance = _this$param2.quoteBalance;
      var isVaild = this.isNumberStrVaild;
      var perVolume = customPerVolume || grid_per_volume;
      if (!isVaild(high) || !isVaild(low) || !high || !low) {
        throw TradeCreateOrderError.Grid_Price_Empty;
      }
      if (!grid_count) {
        throw TradeCreateOrderError.Grid_Grids_Count_Empty;
      }
      if (grid_count < 2 || grid_count >= 100) {
        throw TradeCreateOrderError.Grid_Count_Error;
      }
      if (!perVolume || !isVaild(perVolume)) {
        throw TradeCreateOrderError.Grid_Get_PerVolume_Error;
      }
      if (baseBalance === undefined || quoteBalance === undefined) {
        throw TradeCreateOrderError.Balance_Get_Failed;
      }
      if (low >= high) {
        throw TradeCreateOrderError.Grid_Price_Rance_Error;
      }
      var request = {
        high: high,
        low: low,
        perVolume: perVolume,
        gridCount: grid_count,
        baseAvailable: baseBalance,
        quoteAvailable: quoteBalance
      };
      return request;
    }
  }, {
    key: "checkGridOrderRequest",
    value: function checkGridOrderRequest() {
      var _this$param3 = this.param,
        grid_per_volume = _this$param3.grid_per_volume,
        grid_min_per_volume = _this$param3.grid_min_per_volume,
        high = _this$param3.high,
        low = _this$param3.low,
        stop = _this$param3.stop,
        grid_count = _this$param3.grid_count,
        ticker = _this$param3.ticker,
        grid_required_result = _this$param3.grid_required_result,
        avaliableBalance = _this$param3.avaliableBalance,
        baseBalance = _this$param3.baseBalance,
        quoteBalance = _this$param3.quoteBalance,
        symbol = _this$param3.symbol;
      var isVaild = this.isNumberStrVaild;
      if (!ticker) {
        throw TradeCreateOrderError.NO_Ticker;
      }
      if (!grid_required_result || !avaliableBalance || baseBalance === undefined || quoteBalance === undefined) {
        throw TradeCreateOrderError.Balance_Get_Failed;
      }
      if (!isVaild(high) || !isVaild(low) || !low || !high) {
        throw TradeCreateOrderError.Grid_Price_Empty;
      }
      if (!isVaild(grid_per_volume) || !isVaild(grid_count) || !grid_per_volume || !grid_count) {
        throw TradeCreateOrderError.Grid_Params_Error;
      }
      if (stop) {
        if (stop >= high || stop >= low || low >= high) {
          throw TradeCreateOrderError.Grid_Price_Rance_Error;
        }
        if (stop >= ticker.latest) {
          throw TradeCreateOrderError.Grid_Price_Stop;
        }
      } else {
        if (low >= high) {
          throw TradeCreateOrderError.Grid_Price_Rance_Error;
        }
      }
      if (grid_count < 2 || grid_count >= 100) {
        throw TradeCreateOrderError.Grid_Count_Error;
      }
      if (grid_min_per_volume) {
        if (grid_min_per_volume > grid_per_volume) {
          throw TradeCreateOrderError.Grid_per_Volume_Hit_Amount_Min;
        }
      }
      var request = {
        base: symbol.base,
        quote: symbol.quote,
        type: OrderTypeDesc.GRID,
        high: NumberUtils.toPriceBySymbol(high, symbol),
        low: NumberUtils.toPriceBySymbol(low, symbol),
        stop: stop ? NumberUtils.toPriceBySymbol(stop, symbol) : "0",
        amount: NumberUtils.toAmountBySymbol(grid_per_volume, symbol),
        number: "".concat(grid_count)
      };
      var needBase = NumberUtils.toAmountNumBySymbol(grid_required_result.needBase, symbol, Decimal.ROUND_UP);
      if (needBase > baseBalance) {
        var error = TradeCreateOrderError.Grid__Need_Buy_Base_To_Create_Order;
        var baseOffset = needBase - baseBalance;
        error.info.baseInfo = NumberUtils.toAmountBySymbol(baseOffset, symbol, Decimal.ROUND_UP) + symbol.baseDisplay;
        error.info.result = request;
        throw error;
      }
      var needQuote = NumberUtils.toPriceNumBySymbol(grid_required_result.needQuote, symbol, Decimal.ROUND_UP);
      if (needQuote > quoteBalance) {
        var _error = TradeCreateOrderError.Grid__Need_Sell_Base_To_Create_Order;
        var quoteOffset = needQuote - quoteBalance;
        var needToSellBase = NumberUtils.toAmountBySymbol(quoteOffset / ticker.latest, symbol, Decimal.ROUND_UP);
        _error.info.baseInfo = needToSellBase + symbol.baseDisplay;
        _error.info.result = request;
        throw _error;
      }
      return request;
    }
  }]);
  return GridCreateOrderModel;
}(TradeCreateOrderBaseModel);
export default GridCreateOrderModel;